import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, onMounted } from 'vue';
import { VueCookies } from 'vue-cookies';
import { Md5 } from 'ts-md5';

import Cookies from '@/layouts/Cookies.vue';

import config from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const cookies = inject<VueCookies>('$cookies');

const getAuthUserHash = async function getAuthUserHash() {
  const jsonIp = await fetch('https://jsonip.com', { mode: 'cors' });
  const { ip } = await jsonIp.json();
  const userAgent = window.navigator.userAgent;
  const timeInMs = Date.now();

  return Md5.hashStr(`${userAgent}${ip}${timeInMs}`);
};

onMounted(async () => {
  const authUserHash = cookies?.get('auth_user_hash');

  if (!authUserHash) {
    const userHash = await getAuthUserHash();

    cookies?.set('auth_user_hash', userHash);
  }

  const appKey = cookies?.get('app_key');

  if (!appKey) {
    cookies?.set('app_key', config.appKey);
  }

  if (window.location.hostname === config.siteHost) {
    const addScript = (name: string) => {
      const plugin = document.createElement('script');

      plugin.setAttribute('src', `/scripts/${name}.js?v=1`);
      plugin.async = true;

      document.head.appendChild(plugin);
    };

    addScript('newrelicjs');
    addScript('clarity');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode("Lily Plants | " + _toDisplayString(content), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_view),
    _createVNode(Cookies)
  ], 64))
}
}

})